module.exports = {
  "SkillsPassport": {
    "Locale": "en",
    "DocumentInfo": {
      "DocumentType": "ECV",
      "CreationDate": "2013-02-21T07:47:20.086Z",
      "LastUpdateDate": "2015-06-03T12:14:56.820Z",
      "XSDVersion": "V3.3",
      "Generator": "FUIFI",
      "Comment": "Europass CV",
      "EuropassLogo": true
    },
    "PrintingPreferences": {
      "ECV": [{
        "name": "LearnerInfo.Identification.PersonName",
        "show": true,
        "order": "FirstName Surname"
      }, {
        "name": "LearnerInfo.Identification.Demographics.Birthdate",
        "show": false,
        "format": "numeric/long"
      }, {
        "name": "LearnerInfo.Identification.Demographics.Gender",
        "show": false,
        "format": "numeric/long"
      }, {
        "name": "LearnerInfo.WorkExperience[0].Period",
        "show": true,
        "format": "numeric/long"
      }, {
        "name": "LearnerInfo.WorkExperience[1].Period",
        "show": true,
        "format": "numeric/long"
      }, {
        "name": "LearnerInfo.WorkExperience[2].Period",
        "show": true,
        "format": "numeric/long"
      }, {
        "name": "LearnerInfo.Education[0].Period",
        "show": true,
        "format": "numeric/long"
      }, {
        "name": "LearnerInfo.Education[1].Period",
        "show": true,
        "format": "numeric/long"
      }, {
        "name": "LearnerInfo",
        "show": true,
        "order": "Identification Headline WorkExperience Education Skills Achievement ReferenceTo"
      }]
    },
    "LearnerInfo": {
      "Identification": {
        "PersonName": {
          "FirstName": "",
          "Surname": ""
        },
        "ContactInfo": {
          "Address": {
            "Contact": {
              "AddressLine": "",
              "PostalCode": "",
              "Municipality": "",
              "Country": {
                "Code": "ES",
                "Label": "Spain"
              }
            }
          },
          "Email": {
            "Contact": ""
          },
          "Telephone": [{
            "Contact": "(no disp)",
            "Use": {
              "Code": "home",
              "Label": "Home"
            }
          }, {
            "Contact": "(no disp)",
            "Use": {
              "Code": "mobile",
              "Label": "Mobile"
            }
          }],
        },
        "Demographics": {
          /*
          "Birthdate": {
            "Year": 1975,
            "Month": 3,
            "Day": 1
          },
          */
        },
        "Photo": {
          "MimeType": "image/jpeg",
          "Data": null,
          "Metadata": [ {
            "Key" : "dimension",
            "Value" : "600x600"
          }, {
            "Key" : "number-of-pages",
            "Value" : "1"
          } ]
        }
      },
      "Headline": {
        "Type": {
          "Code": "position",
          "Label": "POSICIÓN"
        },
        "Description": {
          "Label": "European project manager"
        }
      },
      "WorkExperience": [],
      "Skills": {
        "Linguistic": {
          "MotherTongue": [{
            "Description": {
              "Code": "en",
              "Label": "English"
            }
          }],
          "ForeignLanguage": [{
            "Description": {
              "Code": "fr",
              "Label": "French"
            },
            "ProficiencyLevel": {
              "Listening": "C1",
              "Reading": "C2",
              "SpokenInteraction": "B2",
              "SpokenProduction": "C1",
              "Writing": "C2"
            },
            "Certificate": [{
              "Title": "Dalf C1"
            }]
          }]
        },
        "Communication": {
          "Description": "- team work: I have worked in various types of teams from research teams to national league hockey. For 2 years I coached my university hockey team<br />- mediating skills: I work on the borders between young people, youth trainers, youth policy and researchers, for example running a 3 day workshop at CoE Symposium ‘Youth Actor of Social Change’, and my continued work on youth training programmes<br />- intercultural skills: I am experienced at working in a European dimension such as being a rapporteur at the CoE Budapest ‘youth against violence seminar’ and working with refugees."
        },
        "Organisational": {
          "Description": "- whilst working for a Brussels based refugee NGO ‘Convivial’ I organized a ‘Civil Dialogue’<br />between refugees and civil servants at the European Commission 20th June 2002<br />- during my PhD I organised a seminar series on research methods"
        },
        "Computer": {
          "Description": "- competent with most Microsoft Office programmes<br />- experience with HTML"
        },
        "Driving": {
          "Description": ["A", "B"]
        },
        "Other": {
          "Description": "Creating pieces of Art and visiting Modern Art galleries. Enjoy all sports particularly hockey, football and running. Love to travel and experience different cultures."
        }
      },
      "Achievement": [{
        "Title": {
          "Code": "publications",
          "Label": "Publications"
        },
        "Description": "‘How to do Observations: Borrowing techniques from the Social Sciences to help Participants do Observations in Simulation Exercises’ Coyote EU/CoE Partnership Publication, (2002)."
      }]
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/services/europass-sample.js
// module id = 1146
// module chunks = 112